exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ":host .text {\n  padding-top: 7px;\n  text-align: left; }\n\n:host .dirty {\n  font-weight: bold; }\n\n:host .link {\n  cursor: pointer; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_develop@2/app/Resources/Public/src/app/modules/project-details/components/userdata-file/userdata-files/upload-files.component.scss
// module id = ../../../../../src/app/modules/project-details/components/userdata-file/userdata-files/upload-files.component.scss
// module chunks = main